/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// actions
import { setUniqueEmailCollectionProperty } from 'state/actions/embedsState/embedManagementState/content_status';
import { connect } from 'react-redux';
// component
import EmailCollection from 'pages/dashboard/embeds/management/addons/addontypes/emailcollection/emailcollection';



/* ========== ~~~~~~~~~~ EMBED EDITOR : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    queuePosition: embedsState.embedManagementState.contentStatus.addons.userDataCollection.queuePosition,
    contentUUID: embedsState.embedManagementState.contentStatus.addons.userDataCollection.contentUUID,
    location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
    content: embedsState.embedManagementState.contentStatus['contents'],
    mocked: sessionStatus.mocked,

});

const mapDispatchToProps = dispatch => ({
    setUniqueEmailCollectionProperty: (property, value) => dispatch(setUniqueEmailCollectionProperty(property, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmailCollection);
